module.exports = __webpack_public_path__ + "img/content4-8.4a7dbc1a.png";